import { makeStyles, Menu, MenuGroup, MenuGroupHeader, MenuList, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import Status from "../../../enums/Status";
import { useTranslation } from "react-i18next";
import DesktopArea from "./DesktopArea";
import MenuHeader from "./MenuHeader";
import MenuItemLink from "./MenuItemLink";
import MenuLink from "./MenuLink";
import { dolphinTokens } from "../../../utils/Theme";
import INavigationArea from "../../../models/navigation/INavigationArea";

const useStyles = makeStyles({
    menu: {
        display: "flex",
		alignItems: "center",
		gap: "1rem",
		
		"@media (max-width: 768px)": {
			display: "none",
		}
    },
    storyMenuList: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "1rem",
    },
    group: {
        padding: "10px 15px",
    },
    header: {
        color: dolphinTokens.colorLightBlue,
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "uppercase",
        marginTop: "0.5em",
    }
});

interface IDesktopMenuProps {
    areas: INavigationArea[];
    status: Status;
}

export default function DesktopMenu(props: IDesktopMenuProps) {
    const { areas: areas, status } = props;

    const { t } = useTranslation("navigation");
    const styles = useStyles();

    return (
        <div className={styles.menu}>
            <MenuLink to="/" label={t("home")} />
            <Menu positioning={{ autoSize: true }} openOnHover hoverDelay={0}>
                <MenuTrigger disableButtonEnhancement>
                    <MenuHeader label={t("ourStory.ourStory")} />
                </MenuTrigger>
                <MenuPopover>
                    <MenuList className={styles.storyMenuList}>
                        <MenuGroup className={styles.group}>
                            <MenuGroupHeader className={styles.header}>
                                {t("ourStory.about")}
                            </MenuGroupHeader>

                            <MenuItemLink to="/ourstory" label={t("ourStory.ourStory")} />
                            <MenuItemLink to="/partners" label={t("ourStory.partners")} />
                            <MenuItemLink to="/jobs" label={t("ourStory.jobs")} />
                            <MenuItemLink to="/sustainability" label={t("ourStory.sustainability")} />
                        </MenuGroup>
                        <MenuGroup className={styles.group}>
                            <MenuGroupHeader className={styles.header}>
                                {t("ourStory.portfolio")}
                            </MenuGroupHeader>

                            <MenuItemLink to="/casestudies" label={t("ourStory.caseStudies")} />
                            <MenuItemLink to="/testimonials" label={t("ourStory.testimonials")} />
                            <MenuItemLink to="/awards" label={t("ourStory.awards")} />
                        </MenuGroup>
                    </MenuList>
                </MenuPopover>
            </Menu>
            {
                areas.map((area) => <DesktopArea key={area.id} area={area} />)
            }
            <MenuLink to="/blogs" label={t("blog")} />
            <MenuLink to="/contact" label={t("contact")} primary={true} />
        </div>
    );
}